import { classNames } from '@progress/kendo-react-common';
import ImpersonateButton from './ImpersonateButton/ImpersonateButton';
import ImpersonationBarInfo from './ImpersonateBarInfo/ImpersonationBarInfo';
import SelectAccountButton from './SelectAccountButton/SelectAccountButton';
import StopImpersonatingButton from './StopImpersonatingButton/StopImpersonatingButton';
import { useImpersonateInfo, useRealUserInfo, useAccountInfo, useAccounts } from 'state';
import styles from './ImpersonationBar.module.scss';

export default function ImpersonationBar() {
    const impersonateInfo = useImpersonateInfo();
    const accountInfo = useAccountInfo();
    const accounts = useAccounts();
    const { isInternalUser } = useRealUserInfo();

    const accountNumber = impersonateInfo?.accountId ?? accountInfo.accountId;
    const accountName = impersonateInfo?.fullName ?? accountInfo.accountName;
    const heading = impersonateInfo ? 'Impersonating' : (accountNumber ? 'Account' : 'No Account Selected');

    return (
        <div className={classNames(styles.impersonationBarContainer, {
                [styles.yellowBackground] : impersonateInfo,
                [styles.greenBackground] : !impersonateInfo,
            })}
        >
            <div className={styles.impersonationBar}>
                <ImpersonationBarInfo 
                    heading={heading} 
                    accountNumber={accountNumber} 
                    accountName={accountName} 
                /> 
                {!impersonateInfo && ((isInternalUser || accounts.length > 0)) && <SelectAccountButton />}
                {isInternalUser ?
                        (impersonateInfo) ?
                            <StopImpersonatingButton />
                        :
                            <ImpersonateButton />
                    : null
                }
            </div>
        </div>
    );
}